export const environment = {
  production: true,
  apiUrl: 'https://ec2.backend.rule10b51.prod.eu-central-1.master.2iq.cloud',
  form144ApiUrl: 'https://ec2.form144-backend.2iq.eu',
  oauthProviderUrl: 'https://2iq-prod.auth.eu-central-1.amazoncognito.com/oauth2/authorize',
  clientId: '22jacd7ovjl12h7hu3s41ivo2c',
  userInfo: 'https://2iq-prod.auth.eu-central-1.amazoncognito.com/oauth2/userInfo'
};
